import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { CommonMessageService } from '../services/common-message.service';
import { MasterDataService } from '../services/master-data.service';

@Component({
  selector: 'app-independence-decrelation',
  templateUrl: './independence-decrelation.component.html',
  styleUrls: ['./independence-decrelation.component.css'],
})
export class IndependenceDecrelationComponent implements OnInit {

  @Input() decleration
  @ViewChild('content') private content;
  @Output() redirectDashboard = new EventEmitter<{ redirect: boolean }>()
  // @ViewChild('content') content:ElementRef;
  page = 1;
  pageSize = 15;
  todaysDate;
  explanation = ''
  closeResult = ''
  declerationObj;
  clientDeclerationObj = null;
  declerationPendingObj;
  userDetailsObj;
  allClientList;
  declerationName;
  partnerAssignedArray;
  constructor(private modalService: NgbModal, public router: Router, private masterDataService: MasterDataService,
    private commonMessageService:CommonMessageService) {
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    setTimeout(() => {
      // this.decleration.declaration.id = 2;
      if (this.decleration != null) {
        //this.decleration.declaration.id = 4;
        if (this.decleration.declaration.id == '1') {
          this.declerationName = 'Employee Independence'
        } else if (this.decleration.declaration.id == '2') {
          this.declerationName = 'Annual All Client Independence'
        } else if (this.decleration.declaration.id == '3') {
          this.declerationName = 'Client Independence'
        } else if (this.decleration.declaration.id == '4') {
          this.declerationName = 'Annual Firm Personnel Independence'
        }else if (this.decleration.declaration.id == '5') {
          this.declerationName = 'CONSENT UNDER THE DIGITAL PERSONAL DATA PROTECTION ACT, 2023 (“the Act”)'
        }

        console.log("declerationObject", this.decleration)
        this.masterDataService.getDecleration(this.decleration.declaration.id)
          .subscribe(res => {
            console.log("decerlation :", res);
            this.declerationObj = res;
            this.createUserDecerlationObj();
            console.log(localStorage.getItem('id'))
          });
        if (this.decleration.declaration.id == '3') {
          console.log("in Client Decleration")
          this.masterDataService.getClientDetails(this.decleration.client.id)
            .subscribe(res => {
              this.clientDeclerationObj = res
              console.log("client object display", this.clientDeclerationObj)

              this.partnerAssignedArray = this.clientDeclerationObj.client.partners.filter((v, i, a) => a.findIndex(t => (t.place === v.place && t.name === v.name)) === i);

              //this.clientDeclerationObj.client.partners.push({id:21234})
            })
        }
        
        // || this.decleration.declaration.id == '4'
        else if (this.decleration.declaration.id == '2' || this.decleration.declaration.id == '1' || this.decleration.declaration.id == '4' ) {
          console.log("in All annual Decleration")
          this.masterDataService.getAllClientListForDecleration()
            .subscribe(res => {
              console.log("AllClientList", res)
              this.allClientList = res;
              this.masterDataService.getUserProfileByIdForDecleration(this.decleration.user.userId)
                .subscribe(res => {
                  console.log("getUserProfileByIdForDecleration", res)
                  this.userDetailsObj = res
                  this.onPageChange()
                  this.open(this.content);
                })
            })
        }
        if (this.decleration.declaration.id != '2' && this.decleration.declaration.id != '1' && this.decleration.declaration.id != '4') {
          this.masterDataService.getUserProfileByIdForDecleration(this.decleration.user.userId)
            .subscribe(res => {
              console.log("getUserProfileByIdForDecleration", res)
              this.userDetailsObj = res
              this.openDeclerationStatus = true
              this.open(this.content);
            })
        }
        // if (this.decleration.declaration.id=='4') {
        //   this.masterDataService.getUserProfileByIdForDecleration(this.decleration.user.userId)
        //     .subscribe(res => {
        //       console.log("getUserProfileByIdForDecleration", res)
        //       this.userDetailsObj = res
        //       this.openDeclerationStatus = true
        //       this.open(this.content);
        //     })
        // }
      }
    }, 1000)
  }
  open(content) {
    this.modalService
      .open(this.content, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'lg',
        windowClass: 'animate__animated animate__slideInUp animate__faster',
        backdrop: 'static',
        keyboard: false
      })
      .result.then(
        (result) => { },
        (reason) => { }
      );
  }

  closeModal(content) {

    if (content == 'cross click') {
      Swal.fire({
        title: 'You will be logout?',
        showCancelButton: true,
        confirmButtonText: `Log out`,
        confirmButtonColor:'#800000',
      }).then((result) => {
        if (result.isConfirmed) {
          this.modalService.dismissAll()
          this.router.navigateByUrl('login')
        }
      })

    } else {
      this.modalService.dismissAll()
    }

  }

  private getDismissReason(reason: any): string {

    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  data: any;
  createUserDecerlationObj() {

    this.data = {}

    console.log("declerationCreateUserObject", this.declerationObj)

    this.data.client = this.decleration.client

    this.data.declaration = {
      id: this.decleration.declaration.id
    }
    this.data.dissagreementAnswer = this.explanation;
    this.data.signedDate = this.todaysDate
    this.data.user = {
      id: this.decleration.user.id
    }
    this.data.userDeclrationAnswers;
    var userDeclrationAnswers = [];
    for (let i = 0; i < this.declerationObj.questions.length; i++) {
      var questionsObj = {
        answer: false,
        declarationQuestion: {
          id: this.declerationObj.questions[i].id,
          question: this.declerationObj.questions[i].question
        }
      }
      console.log(questionsObj)
      userDeclrationAnswers.push(questionsObj)
    }
    this.data.userDeclrationAnswers = userDeclrationAnswers

    console.log("data", this.data)
  }

  disabledExpliantion : boolean = false
  onAgreeChanged(agreeChanged: { agree: boolean, id: number }) {
    console.log("onAgreeChnaged", agreeChanged)
    for (let i = 0; i < this.data.userDeclrationAnswers.length; i++) {
      if (this.data.userDeclrationAnswers[i].declarationQuestion.id == agreeChanged.id) {
        this.data.userDeclrationAnswers[i].answer = agreeChanged.agree;
      }
    }
    var count = 0
    this.data.userDeclrationAnswers.map(resp =>{
      if(resp.answer){
        count = count + 1
      }
    })
    if(count == this.data.userDeclrationAnswers.length){
      this.disabledExpliantion=true;
    }else{
      this.disabledExpliantion=false;
    }
    console.log("dataOnAgreeChnaged", this.data)
  }
  sign = false;
  onSigned() {

    this.sign = !this.sign
    console.log("onSigned", this.sign)
    if (this.sign) {
      //2021-02-22T12:27:48.000+00:00
      this.todaysDate = moment(new Date()).format("YYYY-MM-DDTHH:mm:ss")
      console.log(this.todaysDate)
    } else {
      this.todaysDate = ''
    }
  }

  onSaveDecleration() {
    var declerationValid = true;
    if (this.sign) {
      for (let i = 0; i < this.data.userDeclrationAnswers.length; i++) {
        if (this.data.userDeclrationAnswers[i].answer == false) {
          var showAlertInvalidExplianation = false
          this.explanation = this.explanation.replace(/\s\s+/g, ' ');
          if (this.explanation == '' || this.explanation == ' ') {
            showAlertInvalidExplianation = true
            declerationValid = false
          }
        }
      }
      if (showAlertInvalidExplianation) {
         this.commonMessageService.swalAlertWithoutIcon('',"Please provide explaination if you disagree to any of the question")
      }
    } else {
       this.commonMessageService.swalAlertWithoutIcon('',"please sign the independence")
      declerationValid = false;
    }

    if (declerationValid) {
      console.log("Valid")
      this.masterDataService.saveIndependenceDecleration(this.getJSONForSaveDecleration())
        .subscribe(res => {
          console.log("saveIndependenceDecleration :", res);
          this.masterDataService.getIndependenceDeclerationMail(res.id).subscribe((res) => {
            console.log('getIndependenceDeclerationMail ', res);
          });
          this.closeModal('save close')
          console.log("navigate")
          this.redirectDashboard.emit({ redirect: true })
        });
    }
  }

  getJSONForSaveDecleration() {
    console.log("getJSONForSaveDecleration", this.data)

    this.data.dissagreementAnswer = this.explanation
    this.data.signedDate = this.todaysDate

    return JSON.stringify(this.data)
  }
  enableDecleration = false
  onPageChange() {
    console.log(this.allClientList.length)
    if (this.allClientList.length < 16) {
      this.enableDecleration = true
    } else {
      console.log("page", this.page)
      var lastPage = Math.ceil(this.allClientList.length / 15);
      console.log("lastPage", lastPage)
      if (lastPage == this.page) {
        this.enableDecleration = true
      } else {
        this.enableDecleration = false
      }
    }
  }
  openDeclerationStatus = false;
  openDecleration() {
    this.openDeclerationStatus = true
  }

  onClientListClick() {
    this.openDeclerationStatus = false
    this.sign = false
    this.todaysDate = ''
  }


}
